import { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type Props = {
  id?: string;
  value: string;
  onChange: (valor: string) => void;
  placeholder?: string;
  'aria-describedby'?: string;
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
};

/**
 * Campo de segredo com botão de mostrar/ocultar.
 *
 * Nasce oculto: quem digita costuma estar com a tela compartilhada ou alguém
 * ao lado. O botão existe porque token colado errado é invisível, e conferir
 * caractere a caractere num campo mascarado não é conferência nenhuma.
 */
export function SecretInput({
  id,
  value,
  onChange,
  placeholder,
  autoComplete = 'off',
  required,
  minLength,
  ...rest
}: Props) {
  const idGerado = useId();
  const inputId = id || idGerado;
  const [visivel, setVisivel] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <input
        id={inputId}
        type={visivel ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        minLength={minLength}
        className="ds-input"
        style={{ paddingRight: 40 }}
        aria-describedby={rest['aria-describedby']}
      />
      <button
        type="button"
        onClick={() => setVisivel((v) => !v)}
        aria-label={visivel ? 'Ocultar' : 'Mostrar'}
        aria-pressed={visivel}
        style={{
          position: 'absolute',
          right: 6,
          top: '50%',
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 30,
          height: 30,
          borderRadius: 6,
          border: 0,
          background: 'none',
          color: 'var(--text-dim)',
          cursor: 'pointer',
        }}
      >
        {visivel ? <EyeOff size={15} aria-hidden="true" /> : <Eye size={15} aria-hidden="true" />}
      </button>
    </div>
  );
}
